import { motion } from "framer-motion";
import React from "react";
import { THEMES } from "../../../../common/constants";
import { Theme } from "../../../../common/types";

interface IconBetterspaceProps {
    type?: Theme;
    animate?: boolean;
}

const IconBetterspace = ({
    type = THEMES.LIGHT,
    animate = false,
}: IconBetterspaceProps) => {
    const fills =
        type === THEMES.LIGHT
            ? animate
                ? [
                      { fill: "#9e9e9e99" },
                      { fill: "#9e9e9e99" },
                      { fill: "#6f6f6f99" },
                      { fill: "#6f6f6f99" },
                      { fill: "#cfcfcf99" },
                      { fill: "#cfcfcf99" },
                  ]
                : [
                      { fill: "#679d2e" },
                      { fill: "#679d2e" },
                      { fill: "#527e25" },
                      { fill: "#527e25" },
                      { fill: "#86c741" },
                      { fill: "#86c741" },
                  ]
            : [
                  { fill: "#fff", fillOpacity: 0.9 },
                  { fill: "#fff", fillOpacity: 0.9 },
                  { fill: "#fff", fillOpacity: 0.8 },
                  { fill: "#fff", fillOpacity: 0.8 },
                  { fill: "#fff" },
                  { fill: "#fff" },
              ];

    const paths = [
        "M0,120l97.808,56.373l-0.023,239.533l-97.785,-55.906l0,-240Z",
        "M106.203,308.313l0.002,112.418l103.795,59.269l0,-112.8l-103.797,-58.887Z",
        "M210,367.2l209.998,-119.231l-0.011,112.035l-209.987,119.996l0,-112.8Z",
        "M322.2,293.863l97.8,-55.524l0,-118.339l-97.8,56.391l0,117.472Z",
        "M110.928,56.608l99.073,-56.608l209.999,120l-97.8,56.391l-211.272,-119.783Z",
        "M0,120l97.808,56.373l103.694,-58.768l-99.052,-56.167l-102.45,58.562Z",
    ];

    const getInitialOpacity = (index: number) => (index === 0 ? 0 : 1); // first path starts hidden

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 421 481"
            width="100%"
            height="100%"
        >
            <g>
                {paths.map((path, index) => (
                    <motion.path
                        key={`bs-path-${index}`}
                        d={path}
                        {...fills[index]}
                        initial={{ opacity: getInitialOpacity(index) }}
                        animate={
                            animate ? { opacity: [1, 0, 1] } : { opacity: 1 }
                        }
                        transition={
                            animate
                                ? {
                                      duration: 0.8,
                                      ease: "easeInOut",
                                      repeat: Infinity,
                                      repeatDelay: 1,
                                      times: [0, 0.5, 1],
                                      delay: (paths.length - 1 - index) * 0.15,
                                  }
                                : undefined
                        }
                    />
                ))}
            </g>
        </svg>
    );
};

export default React.memo(IconBetterspace);
